/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "SwitchRolesPageService";
const log: any = LoggerModule.getInstance();

export class SwitchRolesPageService {
  private static instance: SwitchRolesPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): SwitchRolesPageService {
    if (!SwitchRolesPageService.instance) {
      SwitchRolesPageService.instance = new SwitchRolesPageService(props);
    }
    return SwitchRolesPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  // public async getBoxes() {
  //   let content: any = {};
  //   let compProps: any = null;
  //   const agent = getAgent();

  //   compProps = await agent.getBoxes();
  //   return compProps;
  // }

  public async getAUsersRoles() {
    let content: any = {};
    const agent = getAgent();

    content = agent.getAUsersRoles();

    return content;
  }
}
